module.exports = __webpack_public_path__ + "static/media/gif-icon.3f67f6b4.svg";